/**
 * Pure helpers for occurrence-slot roster vs series roster (Fix A).
 * Used by KssTaskCreatedComponent so add-back after occurrence-remove is detectable.
 */

export function kssOccurrenceMinuteKey(dateVal) {
  if (dateVal == null) return null;
  const t = new Date(dateVal).getTime();
  if (Number.isNaN(t)) return null;
  return String(Math.floor(t / 60000));
}

export function sortKssUserIds(ids) {
  return [...(ids || [])].map(String).sort().join(',');
}

/**
 * @param {object} opts
 * @param {string[]} opts.seriesParticipantIds
 * @param {Array<{ date_eventBegin?: string|Date, participantUserIds?: string[] }>} opts.taskEvents
 * @param {string|Date|null} opts.occurrenceDate
 * @returns {string[]}
 */
export function getKssOccurrenceParticipantIds({
  seriesParticipantIds = [],
  taskEvents = [],
  occurrenceDate = null,
} = {}) {
  const seriesIds = [...(seriesParticipantIds || [])].map(String);
  const key = kssOccurrenceMinuteKey(occurrenceDate);
  if (key == null) return seriesIds;

  const match = (taskEvents || []).find(
    (e) => e && kssOccurrenceMinuteKey(e.date_eventBegin) === key,
  );
  if (match && Array.isArray(match.participantUserIds)) {
    return [...new Set(match.participantUserIds.map(String))];
  }
  return seriesIds;
}

export function hasKssOccurrenceRosterChanges(baselineIds, selectedIds) {
  return sortKssUserIds(baselineIds) !== sortKssUserIds(selectedIds);
}
